export default __webpack_public_path__ + "static/media/lg-logo-changed.7df131ab.png";